import { Flex } from 'foundations-components/components/Flex';
import { useMacroSteps } from './hooks/useMacroSteps';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MacrosTray = ({
  selectedMacro,
  onRemoveMacro
}) => {
  const {
    workflowName
  } = useMacroSteps(selectedMacro);
  const [isHovered, setIsHovered] = useState(false);
  return workflowName && /*#__PURE__*/_jsxs(Flex, {
    paddingBlock: "200",
    marginInline: "200",
    blockSize: "40px",
    alignItems: "center",
    justifyContent: "space-between",
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: "100",
    borderBlockStartColor: "border-core-subtle",
    "data-test-id": "macros-tray",
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [/*#__PURE__*/_jsx(Tag, {
      children: workflowName
    }), isHovered && /*#__PURE__*/_jsx(IconButton, {
      size: "extra-small",
      use: "transparent",
      "data-test-id": "remove-macro-button",
      onClick: onRemoveMacro,
      children: /*#__PURE__*/_jsx(RemoveIcon, {})
    })]
  });
};
MacrosTray.displayName = 'MacrosTray';